import { Button } from '@ui/Button';
import { focusModeIconPaths } from 'hooks/usePreferences/customIcons';
import { type ButtonHTMLAttributes } from 'react';
import { FOCUS_MODE_BOX_SHADOW, FOCUS_MODE_GRADIENT } from './focusModeStyles';

type FocusModeButtonProps = {
  isFocusModeOn: boolean;
  onClick: ButtonHTMLAttributes<HTMLButtonElement>['onClick'];
};

const FocusModeIcon = () => (
  <svg width="16" height="18" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    {focusModeIconPaths.map((d) => (
      <path key={d} d={d} fill="white" />
    ))}
  </svg>
);

export const FocusModeButton = ({ isFocusModeOn, onClick }: FocusModeButtonProps) => (
  <span className="relative inline-flex shrink-0 ml-2 group">
    <span
      aria-hidden
      className={`absolute inset-0 rounded-lg pointer-events-none transition-opacity duration-150${isFocusModeOn ? ' opacity-100 group-hover:opacity-85' : ' opacity-0'}`}
      style={{
        background: FOCUS_MODE_GRADIENT,
        boxShadow: isFocusModeOn ? FOCUS_MODE_BOX_SHADOW : undefined,
      }}
    />
    <Button
      type="button"
      onClick={onClick}
      aria-pressed={isFocusModeOn}
      data-testid="focus-mode-button"
      size="small"
      variant="secondary"
      iconLeading={<FocusModeIcon />}
      className={`[&_svg]:size-12 relative h-24 min-w-max whitespace-nowrap px-8 focus-visible:ring-0 focus-visible:ring-offset-0${isFocusModeOn ? ' border-transparent text-white' : ''}`}
      style={
        isFocusModeOn ? { backgroundColor: 'transparent', borderColor: 'transparent' } : undefined
      }
    >
      Focus Mode
    </Button>
  </span>
);
